<script setup lang="ts">
import { useMainStore } from '~/store/main.store';

const mainStore = useMainStore();
const missionSection = ref<HTMLElement | null>(null);
let blurObserver: IntersectionObserver | null = null;

let headerObserver: IntersectionObserver | null = null;

onMounted(() => {
  headerObserver = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      if (entry && !entry.isIntersecting && entry.boundingClientRect.top < 0) {
        mainStore.stretchHeader = true;
      } else {
        mainStore.stretchHeader = false;
      }
    },
    {
      threshold: 0,
      rootMargin: '0px 0px -100% 0px',
    },
  );

  if (missionSection.value) {
    headerObserver.observe(missionSection.value);
  }

  // Blur-on-enter observer
  blurObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target as HTMLElement;
        if (entry.isIntersecting) {
          el.classList.add('is-visible');
        }
      });
    },
    {
      threshold: 0.4,
    },
  );

  // Observe all blur sections
  const sections = document.querySelectorAll<HTMLElement>('.js-blur-section');
  sections.forEach((el) => blurObserver?.observe(el));
});

onUnmounted(() => {
  if (headerObserver) headerObserver.disconnect();
  if (blurObserver) blurObserver.disconnect();
});
</script>

<template>
    <MainHero />

  <div class="component-wrapper" ref="missionSection">
    <MainVideo />
  </div>

  <div class="blur-section js-blur-section">
    <MainMission />
  </div>

    <MainProducts />

  <div class="blur-section js-blur-section">
    <MainTeam />
  </div>

  <div class="blur-section js-blur-section">
    <MainJoin />
  </div>
</template>

<style scoped>
.component-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.blur-section {
  filter: blur(4px);
  transition: filter .5s ease;
  will-change: filter;
  width: 100%;
}

.blur-section.is-visible {
  filter: blur(0);
}
</style>
